export * from './text-highlight-demo.component';
